<template>
  <span class="wechat-pill-wrap" :class="{ 'wechat-pill-with-label': showLabel }">
    <button class="wechat-pill" :class="pillClass" type="button" @click.stop="toggle" ref="btn">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.3.3 0 00.156-.05l1.9-1.065a.96.96 0 01.465-.13.9.9 0 01.258.04 10.6 10.6 0 002.845.392c.314 0 .621-.026.928-.05a6.85 6.85 0 01-.286-1.969c0-3.667 3.365-6.643 7.505-6.643.254 0 .503.02.75.036C16.67 4.735 13.04 2.188 8.692 2.188zm-3.11 4.478a1.1 1.1 0 110 2.199 1.1 1.1 0 010-2.199zm6.607 0a1.1 1.1 0 110 2.199 1.1 1.1 0 010-2.199zM16.238 8.59c-3.572 0-6.471 2.543-6.471 5.682 0 3.14 2.9 5.683 6.47 5.683a7.8 7.8 0 002.274-.34.77.77 0 01.218-.036.8.8 0 01.39.108l1.514.848a.24.24 0 00.125.04.24.24 0 00.237-.241c0-.06-.023-.117-.04-.175l-.313-1.181a.48.48 0 01.017-.238.47.47 0 01.155-.199c1.555-1.146 2.547-2.86 2.547-4.77 0-3.139-2.9-5.681-6.471-5.681h-.652zm-2.404 3.27a.93.93 0 110 1.86.93.93 0 010-1.86zm4.842 0a.93.93 0 110 1.86.93.93 0 010-1.86z"/></svg>
    </button>
    <button v-if="showLabel" class="wechat-pill-label" :class="pillClass" type="button" @click.stop="toggle" ref="labelBtn">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.3.3 0 00.156-.05l1.9-1.065a.96.96 0 01.465-.13.9.9 0 01.258.04 10.6 10.6 0 002.845.392c.314 0 .621-.026.928-.05a6.85 6.85 0 01-.286-1.969c0-3.667 3.365-6.643 7.505-6.643.254 0 .503.02.75.036C16.67 4.735 13.04 2.188 8.692 2.188zm-3.11 4.478a1.1 1.1 0 110 2.199 1.1 1.1 0 010-2.199zm6.607 0a1.1 1.1 0 110 2.199 1.1 1.1 0 010-2.199zM16.238 8.59c-3.572 0-6.471 2.543-6.471 5.682 0 3.14 2.9 5.683 6.47 5.683a7.8 7.8 0 002.274-.34.77.77 0 01.218-.036.8.8 0 01.39.108l1.514.848a.24.24 0 00.125.04.24.24 0 00.237-.241c0-.06-.023-.117-.04-.175l-.313-1.181a.48.48 0 01.017-.238.47.47 0 01.155-.199c1.555-1.146 2.547-2.86 2.547-4.77 0-3.139-2.9-5.681-6.471-5.681h-.652zm-2.404 3.27a.93.93 0 110 1.86.93.93 0 010-1.86zm4.842 0a.93.93 0 110 1.86.93.93 0 010-1.86z"/></svg>
      <span>{{ labelText }}</span>
    </button>
    <div v-show="popoverOpen" class="wechat-popover" :style="popoverStyle" @click.stop ref="popover">
      <template v-if="bindingStatus === 'active'">
        <div class="wechat-status-row">
          <div class="wechat-status-dot" style="background:#07C160"></div>
          <span class="wechat-status-label">微信已连接</span>
        </div>
        <div class="wechat-info-card">
          <div>账号 ID：<span>{{ bindingAccountId }}</span></div>
          <div>绑定时间：<span>{{ formatTime(bindingBoundAt) }}</span></div>
        </div>
        <div class="wechat-hint">连接成功后可通过微信直接发送消息给该 Agent。</div>
        <button class="wechat-unbind-btn" type="button" @click="unbind" :disabled="unbinding">{{ unbinding ? '解绑中…' : '解绑微信' }}</button>
      </template>
      <template v-else-if="bindingStatus === 'disabled'">
        <div class="wechat-status-row">
          <div class="wechat-status-dot" style="background:#e6a23c"></div>
          <span class="wechat-status-label">微信会话已失效</span>
        </div>
        <div class="wechat-hint">会话已失效，请先解绑后重新扫码绑定。</div>
        <button class="wechat-unbind-btn" type="button" @click="unbind" :disabled="unbinding">{{ unbinding ? '解绑中…' : '解绑并重新绑定' }}</button>
      </template>
      <template v-else>
        <div class="wechat-status-row">
          <div class="wechat-status-dot" style="background:#b0bac8"></div>
          <span class="wechat-status-label">微信未连接</span>
        </div>
        <div class="wechat-qr-area">
          <div v-if="qrLoading" class="wechat-qr-placeholder">加载中…</div>
          <canvas v-show="!qrLoading && qrcodeUrl && !qrExpired && !qrError" ref="qrCanvas" class="wechat-qr-canvas"></canvas>
          <div v-if="!qrLoading && qrExpired" class="wechat-qr-placeholder wechat-qr-clickable" @click="requestQrcode">已过期，点击刷新</div>
          <div v-if="!qrLoading && qrError && !qrExpired" class="wechat-qr-placeholder wechat-qr-clickable" @click="requestQrcode">{{ qrError }}</div>
        </div>
        <div v-if="pollStatus === 'scanned'" class="wechat-hint" style="color:#07C160;font-weight:700">已扫码，请在微信中确认</div>
        <div v-else-if="countdown > 0" class="wechat-hint">二维码将在 {{ countdown }}s 后过期</div>
        <div v-else class="wechat-hint">扫描二维码连接微信，连接成功后可通过微信直接发送消息。</div>
      </template>
    </div>
  </span>
</template>

<script>
import QRCode from 'qrcode'
import { api, BASE_URL, getToken } from '../utils/api'

export default {
  name: 'WechatPill',
  props: {
    agentId: { type: String, default: '' },
    showLabel: { type: Boolean, default: false }
  },
  data: function () {
    return {
      popoverOpen: false,
      popoverStyle: {},
      qrLoading: false,
      qrcodeUrl: '',
      qrcodeToken: '',
      qrExpired: false,
      qrError: '',
      pollStatus: '',
      countdown: 0,
      unbinding: false
    }
  },
  computed: {
    storeBinding: function () {
      return this.agentId ? this.$store.state.wechatBindings[this.agentId] : null
    },
    bindingStatus: function () {
      var b = this.storeBinding
      if (!b || !b.bound) return ''
      return (b.binding && b.binding.status) || ''
    },
    bindingAccountId: function () {
      var b = this.storeBinding
      return (b && b.binding && b.binding.account_id) || ''
    },
    bindingBoundAt: function () {
      var b = this.storeBinding
      return (b && b.binding && b.binding.bound_at) || ''
    },
    labelText: function () {
      if (this.bindingStatus === 'active') {
        return '微信已连接 · ' + (this.bindingAccountId || '')
      }
      if (this.bindingStatus === 'disabled') return '微信会话已失效'
      return '微信未连接'
    },
    pillClass: function () {
      if (this.bindingStatus === 'active') return 'connected'
      if (this.bindingStatus === 'disabled') return 'disabled'
      return 'disconnected'
    }
  },
  watch: {
    agentId: function () {
      this.close()
    }
  },
  mounted: function () {
    this._onDocClick = this.onDocClick.bind(this)
    document.addEventListener('click', this._onDocClick)
    this._onVisChange = this.onVisibilityChange.bind(this)
    document.addEventListener('visibilitychange', this._onVisChange)
    var pop = this.$refs.popover
    if (pop) {
      document.body.appendChild(pop)
      this._popoverEl = pop
    }
  },
  beforeDestroy: function () {
    this.stopPolling()
    this.stopCountdown()
    document.removeEventListener('click', this._onDocClick)
    document.removeEventListener('visibilitychange', this._onVisChange)
    if (this._popoverEl && this._popoverEl.parentNode) {
      this._popoverEl.parentNode.removeChild(this._popoverEl)
    }
    this._popoverEl = null
  },
  methods: {
    toggle: function () {
      if (this.popoverOpen) {
        this.close()
      } else {
        this.updatePopoverPosition()
        this.popoverOpen = true
        if (!this.bindingStatus) {
          this.requestQrcode()
        }
      }
    },
    updatePopoverPosition: function () {
      var btn = (this.showLabel && this.$refs.labelBtn) ? this.$refs.labelBtn : this.$refs.btn
      if (!btn) return
      var rect = btn.getBoundingClientRect()
      this.popoverStyle = {
        top: (rect.bottom + 6) + 'px',
        left: Math.max(8, rect.left + rect.width / 2 - 120) + 'px'
      }
    },
    close: function () {
      this.popoverOpen = false
      this.stopPolling()
      this.stopCountdown()
      this.qrcodeUrl = ''
      this.qrcodeToken = ''
      this.qrExpired = false
      this.qrError = ''
      this.pollStatus = ''
      this.countdown = 0
    },
    onDocClick: function (e) {
      if (!this.popoverOpen) return
      if (this.$el && this.$el.contains(e.target)) return
      if (this._popoverEl && this._popoverEl.contains(e.target)) return
      this.close()
    },
    onVisibilityChange: function () {
      if (document.visibilityState === 'hidden') {
        this.stopPolling()
      } else if (this.popoverOpen && !this.bindingStatus && this.qrcodeToken && !this.qrExpired) {
        this.startPolling(this.qrcodeToken)
      }
    },
    requestQrcode: function () {
      var self = this
      self.qrLoading = true
      self.qrExpired = false
      self.qrError = ''
      self.pollStatus = ''
      self.qrcodeUrl = ''
      self.qrcodeToken = ''
      self.stopPolling()
      self.stopCountdown()

      api.postAgentWechatQrcode(self.agentId).then(function (data) {
        if (!self.popoverOpen) return
        self.qrcodeUrl = data.qrcode_url
        self.qrcodeToken = data.qrcode_token
        self.qrLoading = false
        self.$nextTick(function () { self.renderQrcode(data.qrcode_url) })
        self.startCountdown(data.expires_at)
        self.startPolling(data.qrcode_token)
      }).catch(function (e) {
        self.qrLoading = false
        var rd = e && e.responseData
        if (rd && rd.code === 409) {
          self.qrError = ''
          self.$store.dispatch('fetchWechatBinding', self.agentId)
        } else if (rd && rd.code === 403) {
          self.qrError = '无权限操作此 Agent'
        } else if (rd && rd.code === 502) {
          self.qrError = '微信服务暂时不可用'
        } else {
          self.qrError = (e && e.message) || '请求失败'
        }
      })
    },
    renderQrcode: function (url) {
      var canvas = this.$refs.qrCanvas
      if (!canvas) return
      QRCode.toCanvas(canvas, url, { width: 120, margin: 1 }, function () {})
    },
    startCountdown: function (expiresAt) {
      var self = this
      self.stopCountdown()
      var expiresMs = new Date(expiresAt).getTime()
      function tick() {
        var remain = Math.max(0, Math.round((expiresMs - Date.now()) / 1000))
        self.countdown = remain
        if (remain <= 0) {
          self.qrExpired = true
          self.stopPolling()
          self.stopCountdown()
        }
      }
      tick()
      self._countdownTimer = setInterval(tick, 1000)
    },
    stopCountdown: function () {
      if (this._countdownTimer) {
        clearInterval(this._countdownTimer)
        this._countdownTimer = null
      }
    },
    startPolling: function (token) {
      var self = this
      self.stopPolling()
      var controller = new AbortController()
      self._abortController = controller
      var signal = controller.signal
      var startTime = Date.now()
      var MAX_POLL_MS = 5 * 60 * 1000
      var authToken = getToken()
      var url = BASE_URL + '/agents/' + encodeURIComponent(self.agentId) + '/wechat/qrcode/status?token=' + encodeURIComponent(token)

      ;(async function loop() {
        while (Date.now() - startTime < MAX_POLL_MS) {
          if (!self.popoverOpen) break
          try {
            var resp = await fetch(url, {
              signal: signal,
              headers: { 'Authorization': 'Bearer ' + authToken }
            })
            var json = await resp.json()
            var data = (json && json.code === 200) ? json.data : null
            if (!data) break
            self.pollStatus = data.status
            if (data.status === 'confirmed') {
              self.$store.commit('SET_WECHAT_BINDING', {
                agentId: self.agentId,
                binding: { bound: true, binding: data.binding }
              })
              self.stopCountdown()
              self.$emit('binding-changed', { agentId: self.agentId, bound: true })
              break
            }
            if (data.status === 'expired') {
              self.qrExpired = true
              self.stopCountdown()
              break
            }
          } catch (e) {
            if (e.name === 'AbortError') break
            break
          }
        }
      })()
    },
    stopPolling: function () {
      if (this._abortController) {
        this._abortController.abort()
        this._abortController = null
      }
    },
    unbind: function () {
      var self = this
      self.unbinding = true
      api.deleteAgentWechat(self.agentId).then(function () {
        self.$store.commit('SET_WECHAT_BINDING', { agentId: self.agentId, binding: null })
        self.unbinding = false
        self.close()
        self.$emit('binding-changed', { agentId: self.agentId, bound: false })
      }).catch(function (e) {
        self.unbinding = false
        var rd = e && e.responseData
        if (rd && rd.code === 404) {
          self.$store.commit('SET_WECHAT_BINDING', { agentId: self.agentId, binding: null })
          self.close()
          self.$emit('binding-changed', { agentId: self.agentId, bound: false })
        }
      })
    },
    formatTime: function (iso) {
      if (!iso) return '-'
      var d = new Date(iso)
      var pad = function (n) { return n < 10 ? '0' + n : '' + n }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
    }
  }
}
</script>
